class DataStoreDataProvider {
  dataStore

  getMethod

  updateMethod

  data

  totalCount

  rowIdentifier = 'id'

  parseData

  constructor(dataStore, getMethod, updateMethod, parseData = true) {
    this.dataStore = dataStore
    this.getMethod = getMethod
    this.updateMethod = updateMethod
    this.parseData = parseData
  }

  rows(page, limit, sorting) {
    return this.dataStore
      [this.getMethod](page, limit, sorting)
      .then(result => {
        if (!this.parseData) {
          this.data = result.data
          this.totalCount = result.count
        } else {
          this.data = result.data.data.map(dataRow => dataRow.attributes)
          this.totalCount = result.data.meta.total
        }

        return {
          data: this.data,
          count: this.totalCount,
        }
      })
  }

  count() {
    if (!this.totalCount) return null

    return this.totalCount
  }

  update(id, dataKey, newValue) {
    const row = this.data.find(row => row[this.rowIdentifier] === id)
    row[dataKey] = newValue

    if (typeof this.updateMethod === 'undefined') {
      return new Promise(resolve => {
        resolve()
      })
    }

    return this.dataStore[this.updateMethod](row, dataKey, newValue)
  }
}

export default DataStoreDataProvider
